// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import Landing from './pages/Landing.jsx';
import Home from './pages/Home.jsx';
import SignIn from './pages/SignIn.jsx';
import SignUp from './pages/SignUp.jsx';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';
import AutoLoans from './pages/AutoLoans.jsx';
import BusinessAndNonprofits from './pages/BusinessAndNonprofits.jsx';
import CDFILenders from './pages/CDFILenders.jsx';
import Consult from './pages/Consult.jsx';
import IslamicFinanceBlog from './pages/IslamicFinanceBlog.jsx';
import BlogPost from './pages/BlogPost.jsx';
import AboutUs from './pages/AboutUs.jsx';
import Careers from './pages/Careers.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';
import TermsAndConditions from './pages/TermsAndConditions.jsx';
import NotFound from './pages/NotFound.jsx';
import ResetPassword from './pages/ResetPassword.jsx';
import ProductList from './pages/ProductList.jsx';
import ServiceList from './pages/ServiceList.jsx';
import Advisors from './pages/Advisors.jsx';
import FAQs from './pages/FAQs.jsx';
import PressCoverage from './pages/PressCoverage.jsx';
import CaseStudies from './pages/CaseStudies.jsx';
import ResourceLibrary from './pages/ResourceLibrary.jsx';
import ResourceLesson from './pages/ResourceLesson.jsx';
import Partner from './pages/Partner.jsx';
import PartnerWithUs from './pages/PartnerWithUs.jsx';
import PartnerSignUp from './pages/PartnerSignUp.jsx';
import PartnerSignIn from './pages/PartnerSignIn.jsx';
import PartnerDashboard from './pages/PartnerDashboard.jsx';
import PartnerAdmin from './pages/PartnerAdmin.jsx';
import CRMDashboard from './pages/crm/Dashboard.jsx';
import FinancingLifecycle from './pages/crm/FinancingLifecycle.jsx';
import InvoicingPayments from './pages/crm/InvoicingPayments.jsx';
import { NONPROFIT_BANKING, PERSONAL_BANKING, TYPES, HOME_LOANS, COMMERCIAL_BANKING, COMMERCIAL_FINANCING, NONPROFIT_FINANCING } from './AllLendersPage.jsx';
import { SERVICE_PROVIDERS } from './ServiceProvidersData.jsx';
import ServiceDetailPage from './pages/ServiceDetailPage.jsx';
import StepResults from './pages/carousel/StepResults.jsx';
import CreateFromTemplate from './pages/CreateFromTemplate.jsx';
import {
  PROFESSIONAL_DEVELOPMENT_PATH,
  professionalDevelopmentCatalogPath,
  professionalDevelopmentLessonPath,
} from './constants/professionalDevelopment.js';

function LegacyCatalogRedirect({ from }) {
  return <Navigate to={professionalDevelopmentCatalogPath(from)} replace />;
}

function LegacyProfessionalDevelopmentLessonRedirect() {
  const { slug } = useParams();
  return <Navigate to={professionalDevelopmentLessonPath(slug)} replace />;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <Header />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/home" element={<Home />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/personal-accounts" element={<ProductList productType={TYPES.PERSONAL_BANKING} lenders = {PERSONAL_BANKING}/>} />
          <Route path="/home-loans" element={<ProductList productType={TYPES.HOME_LOANS} lenders = {HOME_LOANS}/>} />
          <Route path="/commercial-banking" element={<ProductList productType={TYPES.COMMERCIAL_BANKING} lenders = {COMMERCIAL_BANKING}/>} />
          <Route path="/commercialloans" element={<ProductList productType={TYPES.COMMERCIAL_FINANCING} lenders = {COMMERCIAL_FINANCING}/>} />
          <Route path="/business-and-nonprofits" element={<BusinessAndNonprofits />} />
          <Route path="/cdfi-lenders" element={<CDFILenders />} />
          <Route path="/nonprofits-banking" element={<ProductList productType={TYPES.NONPROFIT_BANKING} lenders = {NONPROFIT_BANKING}/>} />
          <Route path="/nonprofits-funding" element={<ProductList productType={TYPES.NONPROFIT_FINANCING} lenders = {NONPROFIT_FINANCING}/>} />
          <Route path="/autoloans" element={<AutoLoans />} />
          <Route path="/consult" element={<Consult />} />
          <Route path="/blog" element={<IslamicFinanceBlog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/products" element={<ProductList productType={TYPES.PERSONAL_BANKING} lenders = {PERSONAL_BANKING}/>} />
          <Route path="/advisors" element={<Advisors />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/press-coverage" element={<PressCoverage />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path={PROFESSIONAL_DEVELOPMENT_PATH} element={<ResourceLibrary />} />
          <Route path={`${PROFESSIONAL_DEVELOPMENT_PATH}/:slug`} element={<ResourceLesson />} />
          <Route path="/academy" element={<LegacyCatalogRedirect from="academy" />} />
          <Route path="/academy/:slug" element={<LegacyProfessionalDevelopmentLessonRedirect />} />
          <Route path="/resource-library" element={<LegacyCatalogRedirect from="resource-library" />} />
          <Route path="/resource-library/:slug" element={<LegacyProfessionalDevelopmentLessonRedirect />} />
          <Route path="/white-papers" element={<LegacyCatalogRedirect from="white-papers" />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/partnerwithus" element={<PartnerWithUs />} />
          <Route path="/partner-signup" element={<PartnerSignUp />} />
          <Route path="/partner-signin" element={<PartnerSignIn />} />
          <Route path="/partner-dashboard" element={<PartnerDashboard />} />
          <Route path="/partner-admin" element={<PartnerAdmin />} />
          <Route path="/crm/admin" element={<CRMDashboard />} />
          <Route path="/crm/financing/:id" element={<FinancingLifecycle />} />
          <Route path="/crm/payments/:id" element={<InvoicingPayments />} />
          <Route path="/services" element={<ServiceList providers={SERVICE_PROVIDERS} />} />
          <Route path="/service/:id" element={<ServiceDetailPage />} />
          <Route path="/step-results" element={<StepResults formData={{}} isSubmitting={false} error={null} onRetry={() => {}} />} />
          <Route path="/create-from-template" element={<CreateFromTemplate />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
